import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import getAssetUrl from '../lib/CDNAsset.js';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ProminentHalfLinkCard from '../components/ProminentHalfLinkCard.js';

import { getHomePageView } from '../store/reducers/fmAPI.js';

import FloodAlertHeroSummary from '../components/FloodAlertHeroSummary.js';

import CommonHeaders from '../components/helmet-headers/CommonHeaders.js';
import Breadcrumbs, { CRUMBS } from '../components/helmet-headers/Breadcrumbs.js';

const DataExplorerIcon = getAssetUrl('DataExplorer-h140.webp');

function DataExplorer() {
	const dispatch = useDispatch();
	const { viewHome } = useSelector(state => state.fmAPI);

	const { t, i18n } = useTranslation();

	// const dispatch = useDispatch();
	// const { basins, fmCoverageAreas } = useSelector(state => state.fmAPI);

	// useEffect(() => {
		// dispatch(getBasins());
		// dispatch(getFloodMapperCoverageAreas());
	// }, [dispatch]);

	useEffect(() => {
		dispatch(getHomePageView());
	}, [dispatch])

	let topFloodAlertBanner = null;
	topFloodAlertBanner = <FloodAlertHeroSummary viewHome={viewHome} />



	return (
		<div>
			<CommonHeaders
				title={t('PAGES.DATA_EXPLORER.PAGE_TITLE')}
				description={t('PAGES.DATA_EXPLORER.PAGE_DESCRIPTION')}
				canonicalUrlPath="/data-explorer"
				canonicalDefaultWebsite="UK"
			/>
			<Breadcrumbs
				builtinCrumbs={[CRUMBS.HOME, CRUMBS.DATA_EXPLORER]}
			/>
			<Row className="align-items-center">
				<Col xs={12} className="text-white bg-dark"><h1 className="h1-blendin h1-dataexplorer">{t('PAGES.DATA_EXPLORER.H1_TITLE')}</h1></Col>
			</Row>
			<Row className="screen-bottom-border">
				<Col xs={12} lg={1} xl={2} className="d-none d-lg-block large-screen-left">&nbsp;</Col>
				<Col xs={12} lg={10} xl={8}>
					{topFloodAlertBanner}
					
					<Row>
						<Col xs={12} className="bg-dark text-white">&nbsp;</Col>
						<Col xs={12} style={{paddingLeft: "6%", paddingRight: "6%", "textAlign": "left"}}>{t('PAGES.DATA_EXPLORER.WELCOME_TEXT')}{/*For more information on how to navigate this section, and what the various terms mean, visit the [Education Center Link].*/}</Col>
						<Col xs={12} className="bg-dark text-white">&nbsp;</Col>
					</Row>
					<Row style={{marginTop: "3px"}}>
						 <Col xs={12} lg={6}>
					    	<ProminentHalfLinkCard
						    	image={DataExplorerIcon}
						    	imageAlt={t('PROMLINKCARDS.FIND_A_STATION.FIND_A_STATION_IMGALT')}
						    	title={t('PROMLINKCARDS.FIND_A_STATION.FIND_A_STATION_TITLE')}
						    	body={t('PROMLINKCARDS.FIND_A_STATION.FIND_A_STATION_BODY')}
						    	buttonText={t('PROMLINKCARDS.FIND_A_STATION.VIEW_STATION_MAP')}
						    	navigationTarget="/data-explorer/stationmap"
					    	/>
					    </Col>
						<Col xs={12} lg={6}>
							<ProminentHalfLinkCard
								image={DataExplorerIcon}
								imageAlt={t('PROMLINKCARDS.SEARCH_SEWAGE.SEARCH_SEWAGE_IMGALT')}
								title={t('PROMLINKCARDS.SEARCH_SEWAGE.SEARCH_SEWAGE_TITLE')}
								body={t('PROMLINKCARDS.SEARCH_SEWAGE.SEARCH_SEWAGE_BODY')}
								navigationTarget={"/data-explorer/search-sewage-report"}
								buttonText={t('PROMLINKCARDS.SEARCH_SEWAGE.SEARCH_SEWAGE_BUTTON_TEXT')}
							/>
						</Col>
						<Col xs={12} lg={6}>
							<ProminentHalfLinkCard
								image={DataExplorerIcon}
								imageAlt={t('PROMLINKCARDS.SEARCH_SEWAGE_OPERATOR_LIVE.SEARCH_SEWAGE_OPERATOR_LIVE_IMGALT')}
								title={t('PROMLINKCARDS.SEARCH_SEWAGE_OPERATOR_LIVE.SEARCH_SEWAGE_OPERATOR_LIVE_TITLE')}
								body={t('PROMLINKCARDS.SEARCH_SEWAGE_OPERATOR_LIVE.SEARCH_SEWAGE_OPERATOR_LIVE_BODY')}
								navigationTarget={"/data-explorer/search-sewage-operator"}
								buttonText={t('PROMLINKCARDS.SEARCH_SEWAGE_OPERATOR_LIVE.SEARCH_SEWAGE_OPERATOR_LIVE_BUTTON_TEXT')}
							/>
						</Col>
						<Col xs={12} lg={6}>
							<ProminentHalfLinkCard
								image={DataExplorerIcon}
								imageAlt={t('PROMLINKCARDS.SEARCH_SEWAGE.SEARCH_SEWAGE_IMGALT')}
								title={t('PROMLINKCARDS.FIVE_DAY_FLOOD_FORECAST.FIVE_DAY_FLOOD_FORECAST_TITLE')}
								body={t('PROMLINKCARDS.FIVE_DAY_FLOOD_FORECAST.FIVE_DAY_FLOOD_FORECAST_BODY')}
								navigationTarget={"/data-explorer/fgs"}
								buttonText={t('PROMLINKCARDS.FIVE_DAY_FLOOD_FORECAST.FIVE_DAY_FLOOD_FORECAST_BUTTON_TEXT')}
							/>
						</Col>
						<Col xs={12} lg={6}>
							<ProminentHalfLinkCard
								image={DataExplorerIcon}
								imageAlt={t('PROMLINKCARDS.FIND_DATA_BY_BASIN.FIND_DATA_BY_BASIN_IMGALT')}
								title={t('PROMLINKCARDS.FIND_DATA_BY_BASIN.FIND_DATA_BY_BASIN_TITLE')}
								body={t('PROMLINKCARDS.FIND_DATA_BY_BASIN.FIND_DATA_BY_BASIN_BODY')}
								navigationTarget={"/data-explorer/basins"}
								buttonText={t('PROMLINKCARDS.FIND_DATA_BY_BASIN.FIND_DATA_BY_BASIN_BUTTON_TEXT')}
							/>
						</Col>
					</Row>
				</Col>
				<Col xs={12} lg={1} xl={2} className="d-none d-lg-block large-screen-right">&nbsp;</Col>
			</Row>
		</div>
	);
}

export default DataExplorer;